import * as Sentry from '@sentry/browser';

export const logException = (error, options = {}) => {
  const errorToSend = typeof error === 'string' ? new Error(error) : error;
  Sentry.withScope((scope) => {
    scope.setExtras(options.metaData);
    Sentry.captureException(errorToSend);
  });
};
